var mfStartupBase = __webpack_require__.mfStartupBase = (function () {
	var hasRun = false;
	var result;
	return function __webpack_require__mfStartupBase() {
		if (hasRun) return result;
		hasRun = true;
		result = (function () {
		__webpack_require__(44355)
		})();
		return result;
	};
})();

var mfAsyncStartup = __webpack_require__.mfAsyncStartup = (function () {
	var hasRun = false;
	var result;
	return function __webpack_require__mfAsyncStartup() {
		if (hasRun) return result;
		hasRun = true;
		var base = mfStartupBase && mfStartupBase();
		var promises = base && base.then ? [base] : [];
		var handlers = __webpack_require__.f;
		if (handlers) {
			var startupChunkIds = [796,750,168,889];
			for (var i = 0; i < startupChunkIds.length; i++) {
				handlers.consumes && handlers.consumes(startupChunkIds[i], promises);
				handlers.remotes && handlers.remotes(startupChunkIds[i], promises);
			}
		}
		result = promises.length ? Promise.all(promises) : base;
		return result;
	};
})();

__webpack_require__.mfStartup = __webpack_require__.x;

var wrapStartup = function (prev, isEntry) {
	prev = typeof prev === "function" ? prev : function () {};
	return function (result, chunkIds, cb) {
		var res = mfAsyncStartup();
		if (isEntry && chunkIds === undefined && result === undefined) {
			return res && res.then ? res.then(function () {}) : Promise.resolve();
		}
		if (isEntry && chunkIds === undefined) chunkIds = [];
		var _this = this;
		var _args = arguments;
		var run = function () {
			return isEntry ? prev.call(_this, result, chunkIds, cb) : prev.apply(_this, _args);
		};
		return res && res.then ? res.then(run) : run();
	};
};

__webpack_require__.x = wrapStartup(__webpack_require__.x);
__webpack_require__.X = wrapStartup(__webpack_require__.X, 1);
